import { compact, invert, isArray } from 'lodash';

import { sanitizeQuery } from '@app/components';
import { trimDoubleQuotes, unescapeQuotes } from '@app/utils';

import {
  AdvancedSearchField,
  AdvancedSearchQualifier,
  fieldsRegex,
  fieldsToMaskMap,
  qualifiersRegex,
  RowValues,
  searchQualifierMaskMap,
} from '../constants';

export const parseMaskedFieldQualifierValue = (
  fieldQualifierValue: string
): RowValues => {
  const regex = new RegExp(`^(${fieldsRegex}) (${qualifiersRegex}) (".*")$`);
  const isQueryStringValid = regex.test(fieldQualifierValue.trim());

  if (!isQueryStringValid) {
    return {
      field: AdvancedSearchField.keywordAnywhere,
      qualifier: AdvancedSearchQualifier.containsAll,
      value: fieldQualifierValue,
      isInvalid: true,
    };
  }

  const [field, qualifier, ...query] = compact(
    fieldQualifierValue.trim().split(regex)
  );
  const value = trimDoubleQuotes(
    unescapeQuotes(sanitizeQuery(isArray(query) ? query.join('') : query))
  );

  return {
    field: invert(fieldsToMaskMap)[field] as AdvancedSearchField,
    qualifier: invert(searchQualifierMaskMap)[
      qualifier
    ] as AdvancedSearchQualifier,
    value,
  };
};
